module.exports = __webpack_public_path__ + "static/media/Apple iPhone 6s Plus Rose Gold.5fd6affd.png";